import {Escola} from "./Escola";
import {User} from "./User";
import {Rol} from "./Rol";
import {Pagina} from "./Pagina";

class UsuariRolEscoles {
    constructor(
        public rols: Array<Rol>,
        public escoles: Array<Escola>,
        public usuaris: Array<User>,
        public pagines: Array<Pagina>,
    ) {}
}

const defaultUsuariRolEscoles: UsuariRolEscoles = {
    rols: [],
    escoles: [],
    usuaris: [],
    pagines: [],
};

export { defaultUsuariRolEscoles, UsuariRolEscoles };
